const formInitialState = {
  giftMessage: '',
  isGift: false,
  errors: {},
  isScrolled: false,
}

export default function giftForm(state = formInitialState, action) {
  switch (action.type) {
    case 'SET_IS_SCROLLED':
      return { ...state, isScrolled: true }

    default:
      return state
  }
}
